module.exports = __webpack_public_path__ + "img/noscore.93352c4c.png";